import { havenOnEarth } from '../Landing/eventDetails';

export const siteOrigin = 'https://yourhaven.ng';
export const defaultImage = `${siteOrigin}/logo512.png`;
export const homeMetadata = {
  title: `Haven on Earth — ${havenOnEarth.date} | Haven Health`,
  description: `Haven on Earth: honest conversations, music and connection. Free entry on ${havenOnEarth.date} at ${havenOnEarth.location}.`,
};
const pages = {
  '/': homeMetadata,
  '/404': { title: 'Page not found | Haven Health', description: 'We couldn’t find that page. Find your way back to Haven or join the waitlist.', noindex: true },
  '/waitlist': { title: 'Haven — Join the waitlist', description: "Real stories, a private place to ask the questions you'd rather not put your name on, and support when you want it. Get on the list and be first to hear what’s next for Haven." },
  '/register-launch': { title: 'Register for Haven on Earth | Haven Health', description: `Register for Haven on Earth on ${havenOnEarth.date} at ${havenOnEarth.location}. Free entry. Come as you are.` },
  '/about': { title: 'About Haven | Haven Health', description: 'Get to know Haven. Uncover what makes Haven the safe place to seek mental wellness and growth.' },
  '/help': { title: 'Contact Haven | Haven Health', description: 'Want to talk to us? Get in touch with the Haven team.' },
  '/pricing': { title: 'Pricing | Haven Health', description: 'Explore Haven’s subscription features and support options.' },
  '/privacy': { title: 'Privacy Policy | Haven Health', description: 'Read how Haven collects, uses and protects your personal information.' },
  '/delete-account': { title: 'Delete Your Account | Haven Health', description: 'Request deletion of your Haven account and associated data.' },
  '/media-and-press': { title: 'Media & Press | Haven Health', description: 'Basic information, approved assets and contact details to help you tell the Haven story accurately.' },
  '/media-and-press/releases': { title: 'From Haven | Haven Health', description: 'Press releases, launch notes and perspectives from the Haven team.' },
};
export function getPageMetadata(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/';
  const article = /^\/media-and-press\/[^/]+$/.test(path);
  const missing = !pages[path] && !article && !['/signup', '/confirm', '/login', '/reset', '/download', '/download2'].includes(path);
  return {
    title: missing ? 'Page not found | Haven Health' : 'Haven Health', description: 'Building better ways to find clarity, comfort and support in everyday life.',
    image: defaultImage, imageAlt: 'Haven Health', type: 'website',
    noindex: !pages[path] && !article,
    ...pages[path],
    canonical: `${siteOrigin}${path}`,
  };
}
function meta(attribute, key, value) {
  const selector = `meta[${attribute}="${key}"]`;
  const matches = [...document.head.querySelectorAll(selector)];
  let element = matches.shift();
  matches.forEach(duplicate => duplicate.remove());
  if (!value) { element?.remove(); return; }
  if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.appendChild(element); }
  element.setAttribute('content', value);
}
export function applyMetadata(data) {
  document.title = data.title;
  meta('name', 'description', data.description);
  meta('name', 'robots', data.noindex ? 'noindex, follow' : 'index, follow');
  for (const [key, value] of Object.entries({
    'og:site_name': 'Haven Health', 'og:locale': 'en_NG', 'og:type': data.type,
    'og:title': data.title, 'og:description': data.description, 'og:url': data.canonical,
    'og:image': data.image, 'og:image:alt': data.imageAlt,
    'article:published_time': data.publishedTime,
  })) meta('property', key, value);
  for (const [key, value] of Object.entries({
    'twitter:card': 'summary', 'twitter:site': '@yourhavenhq',
    'twitter:title': data.title, 'twitter:description': data.description,
    'twitter:image': data.image, 'twitter:image:alt': data.imageAlt,
  })) meta('name', key, value);
  const links = [...document.head.querySelectorAll('link[rel="canonical"]')];
  const canonical = links.shift() || document.createElement('link');
  links.forEach(link => link.remove());
  canonical.rel = 'canonical'; canonical.href = data.canonical;
  if (!canonical.isConnected) document.head.appendChild(canonical);
}
